import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingImageToHeicConfig } from '@/data/landingConfig/landingImageToHeicConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ImageToHeic } from './schemaObject';

interface Props {}
const ImageToHeicConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_ImageToHeic} />
			<LandingTemplate
				data={landingImageToHeicConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageToHeic()}
			/>
		</>
	);
};

export default ImageToHeicConverter;
